export type TopbarNotificationId =
	| 'paymentFailed'
	| 'cardExpired'
	| 'cardExpiring'
	| 'jeptoTrial'
	| 'subscriptionEnding'
	| 'dwTrial'
	| 'incentive';

export type TopbarNotificationEligibility = Record<
	TopbarNotificationId,
	boolean
>;

export const TOPBAR_NOTIFICATION_PRIORITY: readonly TopbarNotificationId[] = [
	'paymentFailed',
	'cardExpired',
	'cardExpiring',
	'jeptoTrial',
	'subscriptionEnding',
	'dwTrial',
	'incentive',
];

export const MAX_TOPBAR_NOTIFICATIONS = 2;

export function selectTopbarNotifications(
	eligible: TopbarNotificationEligibility
): TopbarNotificationId[] {
	const visible: TopbarNotificationId[] = [];

	for (const id of TOPBAR_NOTIFICATION_PRIORITY) {
		if (!eligible[id]) {
			continue;
		}

		visible.push(id);
		if (visible.length >= MAX_TOPBAR_NOTIFICATIONS) {
			break;
		}
	}

	return visible;
}
